import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {environment} from "projects/store/src/environments/environment";
import {Router} from "@angular/router";

@Component({
  selector: 'app-sales-phone-enrollment-manual-init-enrollment-datacultr',
  templateUrl: './sales-phone-enrollment-manual-init-enrollment-datacultr.component.html',
  styles: [ ]
})
export class SalesPhoneEnrollmentManualInitEnrollmentDatacultrComponent implements OnInit{
  routesBreadcumbs = ['VENTAS', 'Autogestión', 'Enrolamiento de teléfono']
  customerServicePhone = environment.global.country.customerServicePhone;
  fullPatchUrl!: string;
  visibleModalQR = false;

  @Output() step = new EventEmitter();

  constructor(private router: Router) { }

  ngOnInit() {
    const relativeURL = this.router.url;
    const origin = location.origin;
    // TODO mejorar, pasar a un environment
    this.fullPatchUrl = origin+relativeURL + '?token=WmPiIQ6gWqHDcR3CN2kKFYkBt1Gvg79IX62A424x6dTgFa2rf1KomWMedKipQUbe';
  }

  initEnrollment(){
    this.step.emit('questions-process-datacultr');
  }

}
